import {LngLatBounds} from 'mapbox-gl';

export interface TileCoord {
    z: number;
    x: number;
    y: number;
    bounds?: LngLatBounds;
}

// Converts lng/lat to tile x/y at a specific zoom level
function lngLatToTile(lon: number, lat: number, zoom: number): { x: number; y: number } {
    const z = Math.pow(2, zoom);
    const x = Math.floor(((lon + 180) / 360) * z);
    const y = Math.floor(
        (1 - Math.log(Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)) / Math.PI) /
        2 * z
    );
    return {x, y};
}

// Main function: convert bounding box to tile coordinates
export function bboxToTileList(bounds: LngLatBounds, z: number): TileCoord[] {
    const tileList: TileCoord[] = [];


    const min = lngLatToTile(bounds.getWest(), bounds.getNorth(), z); // top-left
    const max = lngLatToTile(bounds.getEast(), bounds.getSouth(), z); // bottom-right

    for (let x = min.x; x <= max.x; x++) {
        for (let y = min.y; y <= max.y; y++) {
            tileList.push({z, x, y, bounds});
        }
    }

    return tileList;
}
